import { render } from "./FormItem.vue?vue&type=template&id=2306fb2a&scoped=true"
import script from "./FormItem.vue?vue&type=script&lang=js"
export * from "./FormItem.vue?vue&type=script&lang=js"

import "./FormItem.vue?vue&type=style&index=0&id=2306fb2a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2306fb2a"],['__file',"src/components/h5/layout/FormItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2306fb2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2306fb2a', __exports__)) {
    api.reload('2306fb2a', __exports__)
  }
  
  module.hot.accept("./FormItem.vue?vue&type=template&id=2306fb2a&scoped=true", () => {
    api.rerender('2306fb2a', render)
  })

}


export default __exports__